import React from 'react';
import { Loading } from '../../ui';

const ModuleComponents = {
  text: React.lazy(() => import('./components/TextModule')),
  image: React.lazy(() => import('./components/ImageModule')),
  video: React.lazy(() => import('./components/VideoModule')),
  discussion: React.lazy(() => import('./components/DiscussionModule')),
  audio: React.lazy(() => import('./components/AudioModule')),
  slideshow: React.lazy(() => import('./components/SlideshowModule')),
  task: React.lazy(() => import('./components/TaskModule')),
  webinar: React.lazy(() => import('./components/WebinarModule')),
  embed: React.lazy(() => import('./components/EmbedModule')),
  download: React.lazy(() => import('./components/DownloadModule')),
  diploma: React.lazy(() => import('./components/DiplomaModule')),
};

const Module = ({ module, columns, themeColor, isEditMode = false, ...additionalProps }) => {
  const ModuleComponent = ModuleComponents[module.type.name];

  if (!ModuleComponent) {
    console.warn(`Unknown module type: ${module.type.name}`);
    return null;
  }

  const moduleProps = {
    data: module.data,
    module,
    split50: columns === 2,
    themeColor,
    ...additionalProps,
  };

  if(module.type.name === 'image') moduleProps.showLightBox = !isEditMode;

  return (
    <React.Suspense fallback={<Loading themeColor={themeColor} />}>
      <ModuleComponent  {...moduleProps}/>
    </React.Suspense>
  );
};

export default Module;
